export const ModalType = {
  INFO: 'info',
  ALERT: 'alert',
  ERROR: 'error',
  CONFIRM: 'confirm',
  CUSTOM: 'custom',
};

export const ModalResultType = {
  OK: 'ok',
  CLOSE: 'close',
  CANCEL: 'cancel',
};

export class ModalResult {
  constructor(type, payload) {
    this.result = type;
    this.payload = payload;
  }
}
